// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"305":"b0f2620d","546":"a52b9019"}[chunkId] + ".chunk.js";
};